import Vue from 'vue'
import UUID from 'vue-uuid'
import VueCroppie from 'vue-croppie'

import App from '@/App.vue'
import store from '@/store'
import router from '@/router'
import bootstrap from '@/bootstrap'
import '@/assets/global.scss'

import i18nHelper from '@/helpers/i18nHelper'
import VueI18Next from '@panter/vue-i18next'
import i18next from 'i18next'
import json from '@/locales/pt-BR.json'

import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import helpersSettings from '@/helpers/settings'
import jwt from '@/helpers/jwtHelper'
import Toasted from 'vue-toasted'
import VueAnalytics from 'vue-analytics'
import Tooltip from '@/shared/components/Tooltip'
import ToggleButton from 'vue-js-toggle-button'
import Vuelidate from 'vuelidate'

import VueSidebarMenu from 'vue-sidebar-menu'
import 'vue-sidebar-menu/dist/vue-sidebar-menu.css'
import VueClipboard from 'vue-clipboard2'

import VueMoment from 'vue-moment'
import moment from 'moment-timezone'

moment.locale('pt-BR')

import browserHelper from './helpers/browserHelper'

import prettyBytes from '@/filters/prettyBytes'
moment.locale('pt-br')

Vue.config.productionTip = false
const isProd = process.env.NODE_ENV === 'production'

;(async () => {
  Vue.use(UUID)
  Vue.use(VueCroppie)
  Vue.use(VueI18Next)
  Vue.use(VueSidebarMenu)
  Vue.use(VueClipboard)
  Vue.use(VueMoment, { moment })
  Vue.use(BootstrapVue)
  Vue.use(IconsPlugin)
  Vue.use(ToggleButton)
  Vue.use(Vuelidate)
  Vue.use(Toasted, { iconPack: 'fontawesome' })
  Vue.use(VueAnalytics, {
    id: 'UA-56083812-1',
    router,
    debug: {
      enabled: !isProd,
      sendHitTask: isProd,
    },
  })
  Vue.use(prettyBytes)

  Vue.component('Tooltip', Tooltip)
  const { urlReturnSettings } = helpersSettings
  let locale = null
  let config = null

  if (browserHelper.hasUrlParams()) {
    const qToken = browserHelper.getUrlParam('token')
    const qReturnUrl = browserHelper.getUrlParam(urlReturnSettings.key)
    if (qToken) {
      await jwt.update(qToken)

      const query = `?${window.location.search
        .split('&')
        .filter(param => !param.includes('token='))
        .filter(param => !param.includes('returnUrl='))
        .join('&')}`

      window.history.pushState({}, document.title, `${window.location.pathname}${query}`)
    }

    if (qReturnUrl) {
      localStorage.setItem(urlReturnSettings.key, decodeURIComponent(qReturnUrl))
    }

    window.addEventListener('beforeunload', () => {
      localStorage.removeItem(urlReturnSettings.key)
    })
  }

  bootstrap.init()

  try {
    locale = jwt.payload.user.locale || 'pt-BR'
    const translatedJson = await i18nHelper.getLocale(locale)
    config = { lng: locale, resources: {} }
    config.resources[locale] = { translation: translatedJson }
  } catch (error) {
    locale = 'pt-BR'
    config = { lng: locale, resources: {} }
    config.resources[locale] = { translation: json }
  }

  i18next.init({ ...config, returnObjects: true })

  const i18n = new VueI18Next(i18next)

  new Vue({
    store,
    i18n,
    router,
    render: h => h(App),
  }).$mount('#app')
})()
